import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { toast } from 'react-toastify';
import { toastResponse } from '../helper components/Toast/Toast';

// Async thunk using Redux Toolkit's createAsyncThunk
export const Logout = createAsyncThunk(
  'auth/isLogout',
  async (_, { getState, rejectWithValue }) => {
    // try {
    //   // Your logout logic here
    //   // ...

    //   // Return some data if needed
    //   return {};
    // } catch (error) {
    //   // Handle errors
    //   return rejectWithValue(error.response.data);
    // }
  },
);

const initialState = {
  username: sessionStorage.getItem('username')
    ? sessionStorage.getItem('username')
    : '',
  isLogin: sessionStorage.getItem('isLogin')
    ? sessionStorage.getItem('isLogin')
    : false,
  role: sessionStorage.getItem('role') ? sessionStorage.getItem('role') : '',
  token: sessionStorage.getItem('token')
    ? sessionStorage.getItem('token')
    : null,
  enterpriseID: sessionStorage.getItem('enterpriseID')
    ? sessionStorage.getItem('enterpriseID')
    : null,
  enterpriseClientID: sessionStorage.getItem('enterpriseClientID')
    ? sessionStorage.getItem('enterpriseClientID')
    : null,
};

export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    login: (state, action) => {
      state.username = action.payload.userData.email;
      state.isLogin = action.payload.userData.status;
      state.role = action.payload.userData.role;
      state.token = action.payload.enterpriseLogin.loginResponse.standardToken.accessToken;
      state.enterpriseID =
        action.payload.userData.clientId;
      state.enterpriseClientID =
        action.payload.userData.id;
      sessionStorage.setItem('username', state.username);
      sessionStorage.setItem('isLogin', state.isLogin);
      sessionStorage.setItem('role', state.role);
      sessionStorage.setItem('token', state.token);
      sessionStorage.setItem('enterpriseID', state.enterpriseID);
      sessionStorage.setItem('enterpriseClientID', state.enterpriseClientID);
    },
    // login: (state, action) => {
    //   state.username = action.payload.enterpriseLogin.enterpriseClient.email;
    //   state.isLogin = action.payload.enterpriseLogin.enterpriseClient.status;
    //   state.role = action.payload.enterpriseLogin.enterpriseClient.role;
    //   state.token = action.payload.enterpriseLogin.accessToken.token;
    //   state.enterpriseID =
    //     action.payload.enterpriseLogin.enterpriseClient.enterprise.id;
    //   state.enterpriseClientID =
    //     action.payload.enterpriseLogin.enterpriseClient.id;
    //   sessionStorage.setItem('username', state.username);
    //   sessionStorage.setItem('isLogin', state.isLogin);
    //   sessionStorage.setItem('role', state.role);
    //   sessionStorage.setItem('token', state.token);
    //   sessionStorage.setItem('enterpriseID', state.enterpriseID);
    //   sessionStorage.setItem('enterpriseClientID', state.enterpriseClientID);
    // },
    isLogout: (state) => {
      state.username = '';
      state.role = '';
      state.isLogin = '';
      state.token = null;
      sessionStorage.removeItem('username');
      sessionStorage.removeItem('isLogin');
      sessionStorage.removeItem('role');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('enterpriseID');
      sessionStorage.removeItem('enterpriseClientID');
    },
  },
  extraReducers: {
    [Logout.pending]: (state, action) => {},
    [Logout.fulfilled]: (state, action) => {
      sessionStorage.clear();
      sessionStorage.clear();
      state.isLogin = '';
      state.token = null;
      state.enterpriseID = '';
      state.enterpriseClientID = '';
    },
    [Logout.rejected]: (state, action) => {
      toast.error(toastResponse('error', action.error.message));
      sessionStorage.clear();
      sessionStorage.clear();
      state.isLogin = '';
      state.token = null;
      state.enterpriseID = '';
      state.enterpriseClientID = '';
    },
  },
});

// Async action creator using Redux Thunk
export const loginAsync = (userData) => async (dispatch) => {
  try {
    // Dispatch the success action with the response data
    dispatch(login(userData));
  } catch (error) {
    // Dispatch an error action if needed
    toast.error(toastResponse('error', error.message));
  }
};

// Action creators are generated for each case reducer function
export const { login, isLogout } = authSlice.actions;

export default authSlice.reducer;
